export default __webpack_public_path__ + "static/media/7.45dbd592.png";